export default {
    colors: (stats) => {
        switch (stats) {
            case 'ACTIVE':
                return '#3FBF3F';
            case 'PENDING':
                return '#FB5C12';
            case 'ENABLED':
                return '#8F8274';
            case 'DELETED':
                return '#DD1908';
            case 'DISABLED':
                return '#B9DD08';
            case 'DENIED':
                return '#0860DD';
            default:
                return '#ffffff';
        }
    },

    colorStatsSale: (stats) => {
        switch (stats) {
            case 'PAID':
                return '#3FBF3F';
            case 'CANCELED':
                return '#C13333';
            case 'OPEN':
                return '#fb7f12';
            case 'OPEN OVERDUE':
                return '#ee8e7d';
        }
    },

    translateColor(status) {
        switch (status) {
            case 'PAID':
                return '#3FBF3F';
            case 'OPEN':
                return '#fb7f12';
            case 'CANCELED':
                return '#C13333';
        }
    },

    translateStatus(status) {
        switch (status) {
            case 'PAID':
                return 'Paga';
            case 'PAID_LATE':
                return 'Paga com Atraso';
            case 'OVERDUE':
                return 'Atrasada';
            case 'OPEN':
                return 'Aberta';
            case 'CANCELED':
                return 'Cancelada';

        }
    },

    moviments: (word) => {
        switch (word) {
            case 'FIXED':
                return 'Valor Fixo';
            case 'DAILY_PERCENTAGE':
                return 'Porcentagem Diária';
            case 'MONTHLY_PERCENTAGE':
                return 'Porcentagem Mensal';
            case 'DAILY_AMOUNT':
                return 'Valor Diário';
            case 'PERCENTAGE':
                return 'Porcentagem';
        }
    },

    payments: (word) => {
        switch (word) {
            case 'MANUAL':
                return 'Manual';
            case 'AUTOMATIC':
                return 'Automatico';
        }
    },

    word: (word) => {
        switch (word) {
            case 'ACTIVE':
                return 'Ativo';
            case 'OPEN':
                return 'Aberta';
            case 'PENDING':
                return 'Pendente';
            case 'ENABLED':
                return 'Habilitado';
            case 'DELETED':
                return 'Excluído';
            case 'DISABLED':
                return 'Desabilitado';
            case 'DENIED':
                return 'Negado';
            case 'CANCELED':
                return 'Cancelada';
            case 'PAID':
                return 'Quitada';
            default:
                return '';
        }
    },

    parseMoneyOrPercentToFloat(raw) {
        if (raw == null) return null;

        const s0 = String(raw).trim();
        if (!s0) return null;

        const isPercent = s0.includes('%');

        // remove símbolos e espaços comuns
        let s = s0
            .replace(/\s/g, '')
            .replace('R$', '')
            .replace('%', '');

        if (isPercent) {
            // percent: normalmente vem com ponto decimal (25.12)
            // mas se vier com vírgula, também funciona
            s = s.replace(',', '.');
            // mantém só dígitos, ponto e sinal
            s = s.replace(/[^0-9.-]/g, '');
            const n = Number(s);
            return Number.isFinite(n) ? n : null;
        }

        // dinheiro pt-BR: 1.500,00 => 1500.00
        s = s.replace(/\./g, '').replace(',', '.');
        s = s.replace(/[^0-9.-]/g, '');

        const n = Number(s);
        return Number.isFinite(n) ? n : null;
    },

    formatToBRL(value) {
        if (value == null || value === '') return 'R$ 0,00';

        const n = Number(value);
        if (!Number.isFinite(n)) return 'R$ 0,00';

        return new Intl.NumberFormat('pt-BR', {
            style: 'currency',
            currency: 'BRL',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        }).format(n);
    },
};
